import { ConfigField, ConfigTranslatedText } from '@/eventConfig/types.ts';

interface AddRequiredMessageProps {
  field?: ConfigField;
  message: ConfigTranslatedText;
}

// This function modifies a form "Field" defined in config.yaml
// and when a "Required" validator is present it adds the
// message `message` to it. In the slim version of the forms for
// dataSummary slide the Messages are importatn
export const addReqiredMessage = ({ field, message }: AddRequiredMessageProps): ConfigField | undefined => {
  if (field?.validator) {
    const req = field.validator.find(({ type }) => type === 'required');
    if (req) {
      return {
        ...field,
        validator: [{ type: 'required', error: message, defaultTargetValue: '' }, ...field.validator],
      };
    }
  }
  return field;
};
